module.exports = __webpack_public_path__ + "static/media/loading_object.8f5f54d9.png";